<div class="container header">
  <div class="title">
    <img class="menu pointer" (click)="isNavbarOpen = !isNavbarOpen" src="/assets/images/types/menu.svg" />
    <img class="image-header-logo pointer" src="/assets/images/header/questionnaireSite-{{ client }}.svg"
      (click)="goToBoardirector()" />
      <img *ngIf="client == 'directq'" class="image-header-logo pointer logo-sqlink" src="/assets/images/header/sqlink-logo.svg"/>
    <div *ngIf="client != 'directq'">
      <hr class="muiltr-yt4nd1" />
      <p>{{title}}</p>
    </div>
  </div>
  <div class="btn">
    <que-logged-user></que-logged-user>
  </div>
</div>
<div class="container">
  <que-questionnaires-files [isOpen]="isNavbarOpen" class="questionnaires-files"></que-questionnaires-files>
  <div [ngClass]="{ 'nav-open-mobile': isNavbarOpen }" (click)="closeNavMobile()"></div>
  <div class="router-outlet-wrapper" [ngClass]="{ 'nav-close': !isNavbarOpen }">
    <router-outlet></router-outlet>
  </div>
</div>